export const multiStepForm = (fields, expanded=false) => ({
  fields,
  currentFieldIdx: expanded ? fields.length - 1 : 0,
  currentField() {
    return this.fields[this.currentFieldIdx]
  },
  getFieldIdx(field) {
    return this.fields.indexOf(field)
  },
  nextStep() {
    const currentIdx = this.currentFieldIdx
    this.currentFieldIdx = currentIdx <= this.fields.length -1
      ? currentIdx + 1 : currentIdx
    
    currentIdx !== this.currentFieldIdx && this.$nextTick(() => {
      this.$refs[this.currentField()] && this.$refs[this.currentField()].focus()
    })
  },
  previousStep() {
    const currentIdx = this.currentFieldIdx
    this.currentFieldIdx = currentIdx > 0 ? currentIdx - 1 : currentIdx
  },
  isFinalStep() {
    return this.currentFieldIdx === (this.fields.length - 1)
  },
})
